import moment from "moment"
import { TotalInvoiceAmounts } from "../GeneratedClients/FreeBillApi"

const getDefaultInvoiceAmountList: (periodInMonthes: number, lastInvoiceAmount?: TotalInvoiceAmounts) => TotalInvoiceAmounts[] = (periodInMonthes, lastInvoiceAmount) => {
  var periodTo = lastInvoiceAmount && lastInvoiceAmount.month && lastInvoiceAmount.year 
  ? moment(`${lastInvoiceAmount.year}-${lastInvoiceAmount.month}-1`)
  : moment().add(1,"month")
  var periodFrom = periodTo.startOf('month').subtract(periodInMonthes, "months")
  var defaultList = []

  for (let index = 0; index <= periodInMonthes; index++) {
    defaultList.push({month: periodFrom.month() + 1, year: periodFrom.year()})
    periodFrom.add(1, "months")
  }

  return defaultList
}

export default getDefaultInvoiceAmountList